<template>
  <transition name="slide-fade">
    <ul role="menu" class="user-menu" v-show="show" @click="setDarken(false)">
      <li class="user-menu__item user-menu__item--mobile">{{ name }}</li>

      <template v-for="(item, index) in menu">
        <router-link
          v-if="!item.seperator"
          :to="item.route"
          tag="li"
          :key="item.label + index"
          class="user-menu__item user-menu__item--href"
          role="menuitem"
          tabindex="0"
        >
          <font-awesome-icon size="xs" :icon="item.icon" />
          <span class="user-menu__item__label">{{ item.label }}</span>
        </router-link>
        <li
          :key="index"
          v-else
          class="user-menu__seperator"
          role="presentation"
        ></li>
      </template>
    </ul>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'user-menu',
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      items: [
        {
          route: { name: 'profile' },
          label: 'Profile',
          icon: 'user',
        },
        {
          route: { name: 'landing', params: { logout: 'true' } },
          label: 'Log out',
          icon: 'sign-out-alt',
        },
      ],
      admin: [
        {
          route: { name: 'admin' },
          label: 'Admin',
          icon: 'cog',
        },
      ],
    };
  },
  watch: {
    show: function(newVal) {
      this.setDarken(newVal);
    },
  },
  methods: {
    ...mapActions('ui', ['setDarken']),
  },
  computed: {
    ...mapGetters('auth', ['isAdmin', 'name', 'subscription']),
    menu() {
      let menu = [];
      if (this.isAdmin) {
        menu = [...this.admin];

        menu.push({
          seperator: true,
        });
      }

      menu = [...menu, ...this.items];

      return menu;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-menu {
  background: white;
  border-radius: 4px;
  position: absolute;
  top: calc(100% + 1rem);
  margin: 0 0.5rem 0 0;
  list-style: none;
  right: 0;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.08);
  width: 200px;
  z-index: 1100;
  padding: 0;

  &:before {
    user-select: none;
    content: '';
    width: 0rem;
    height: 0rem;
    position: absolute;
    top: -8px;
    right: 0.5rem;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid white;
  }

  &__item {
    display: flex;
    align-items: center;
    font-weight: 400;
    line-height: 1rem;
    padding: 1rem;

    &:focus {
      background: rgba(color('primary'), 0.05);
      outline: none;
      color: color('secondary');
    }

    &--mobile {
      font-weight: 500;
      font-size: 1rem;
      line-height: 1rem;
      margin-bottom: 0.5rem;
    }

    &--href {
      cursor: pointer;

      &:hover {
        color: color('secondary');
      }
    }

    &:last-child {
      margin-bottom: 0;
    }

    &__label {
      margin-left: 1rem;
    }
  }

  &__seperator {
    height: 1px;
    background: color('grey');
  }
}

@media screen and (min-width: 1024px) {
  .user-menu__item--mobile {
    display: none;
  }
}

@media reader, speech, aural {
  .user-menu::before {
    display: none;
    visibility: hidden;
  }
}
</style>
